// frontend/source/portal/pages/AdminLandingPage.js
import React, { useState, useEffect } from "react";
import adminApi from "../../services/adminapi";
import api from "../../services/api";
import EditCategoryCard from "../components/EditCategoryCard";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import ErrorMessage from "../../components/common/ErrorMessage";
import "./AdminLandingPage.css";
import CreateCategoryCard from "../components/CreateCategoryCard";
import ConfirmDialog from "../components/ConfirmDialog";


const AdminLandingPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
   const [deleteConfirm, setDeleteConfirm] = useState({
     isOpen: false,
     category: null,
   });

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const data = await api.getCategories();
      setCategories(data);
      setError(null);
    } catch (err) {
      setError("Failed to load categories. Please try again later.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (categoryId) => {
     const category = categories.find((cat) => cat._id === categoryId);
     setDeleteConfirm({ isOpen: true, category });
  };

  const confirmDelete = async () => {
    try {
      await adminApi.deleteCategory(deleteConfirm.category._id);
      setCategories(
        categories.filter((cat) => cat._id !== deleteConfirm.category._id)
      );
      setDeleteConfirm({ isOpen: false, category: null });
    } catch (err) {
      setError("Failed to delete category. Please try again.");
      console.error(err);
      setDeleteConfirm({ isOpen: false, category: null });
    }
  };

  const cancelDelete = () => {
    setDeleteConfirm({ isOpen: false, category: null });
  };

   const handleUpdate = async (categoryId, updateData) => {
     try {
       const updated = await adminApi.updateCategory(categoryId, updateData);
       setCategories(
         categories.map((cat) => (cat._id === categoryId ? updated : cat))
       );
     } catch (err) {
       setError("Failed to update category. Please try again.");
       console.error(err);
       throw err;
     }
   };

    const handleCreate = async (categoryData) => {
      try {
        const newCategory = await adminApi.createCategory(categoryData);
        // Add new category to the beginning of the list
        setCategories([newCategory, ...categories]);
        setError(null);
      } catch (err) {
        setError("Failed to create category. Please try again.");
        console.error(err);
        throw err;
      }
    };

  if (loading) {
    return <LoadingSpinner message="Loading categories..." />;
  }

  if (error) {
    return <ErrorMessage message={error} onRetry={loadCategories} />;
  }

  return (
    <div className="admin-category-main">
      <div className="admin-category-content">
        <h1 className="admin-category-title">Manage Categories</h1>
        <p className="admin-category-subtitle">Edit or delete art categories</p>

        <div className="admin-categories-grid">
          <CreateCategoryCard onCreate={handleCreate} />
          {categories.map((category) => (
            <EditCategoryCard
              key={category._id}
              category={category}
              onDelete={handleDelete}
              onUpdate={handleUpdate}
            />
          ))}
        </div>
      </div>
      <ConfirmDialog
        isOpen={deleteConfirm.isOpen}
        title="Delete Category?"
        message={`Are you sure you want to delete "${deleteConfirm.category?.name}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
  );
};

export default AdminLandingPage;
